import AddOccupantsModalContainer from "./AddOccupantsModalContainer";

export default AddOccupantsModalContainer;
